import { u as n } from "./use-product-y102e61c.js";
import { u as c, o as l, b as u, c as i, e as p, h as d, as as f, f as m } from "./define-element-XpjsV6s1.js";
import { I as _ } from "./Input-yplyeePD.js";
import { _ as h } from "./_plugin-vue_export-helper-CHgC5LLL.js";
const S = {
  class: "offset-product-list-search",
  ref: "container"
}, y = {
  __name: "ProductListSearch",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    }
  },
  setup(o) {
    const a = o, { searchBy: e } = n(), s = c("container");
    return l(() => {
      u(s.value, a.inheritStyle);
    }), (I, t) => (i(), p("div", S, [
      d(_, {
        label: "Search",
        modelValue: m(e),
        "onUpdate:modelValue": t[0] || (t[0] = (r) => f(e) ? e.value = r : null),
        floating: !0
      }, null, 8, ["modelValue"])
    ], 512));
  }
}, b = /* @__PURE__ */ h(y, [["__scopeId", "data-v-7d2cb986"]]);
export {
  b as P
};
